module.exports = __webpack_public_path__ + "img/magento-modules-customization@2x.13e3b108.jpeg";